import { AssetsUserInfo } from "../models/permissions";
import { ProjectId } from "../types";
import { Endpoints } from "./constants";
import { AssetsHttpClient } from "./createAssetsHttpClient";

export const getUsersClient = (
  http: AssetsHttpClient,
  projectId: ProjectId
) => {
  const base = http.getAssetsServiceBasePath(projectId, "v2");

  return {
    me: (): Promise<AssetsUserInfo> =>
      http.get<AssetsUserInfo>(`${base}/${Endpoints.Users}/me`),
  };
};

/**
 * The shape returned by {@link getUsersClient}.
 * Exported so consumers can type variables without spelling out
 * `ReturnType<typeof getUsersClient>`.
 */
export type UsersClient = ReturnType<typeof getUsersClient>;
